// test1071
(1071 && 0);
